export default __webpack_public_path__ + "static/media/pro-plan.6b52f1b4.webp";